// @flow

import React, {PureComponent} from 'react';
import {CacheOnly, FloatingAddWOTContainer} from './StyledFloatingAddWOT';
import {getBrowserInfo} from '../../utils';
import {FloatingMobile} from './components/FloatingMobile/FloatingMobile';
import {FloatingDesktop} from './components/FloatingDesktop/FloatingDesktop';
import {PhoneImg} from './components/FloatingMobile/StyledFloatingMobile';
import {BrowserImg} from './components/FloatingDesktop/StyledFloatingDesktop';
import {extInstalled} from '../../utils/isExtentionInstalled';

export const CLOSED_KEY = 'add_wot_close_%pageTrackName%';
export const EXTENSION_CTA_KEY = 'add_wot_extension_cta_%pageTrackName%';
export const MOBILE_CTA_KEY = 'add_wot_mobile_cta_%pageTrackName%';

export const EXTENSION = 'extension';
export const MOBILE = 'mobile';

export const getStorageKey = (key: string, pageTrackName: string): string => key.replace('%pageTrackName%', pageTrackName);

type IFloatingAddWOTProps = {
    isHidden?: boolean,
    isSafari?: boolean,
    pageTrackName: string
}

type IFloatingAddWOTState = {
    isSSR: boolean,
    closed: boolean
}

export default class FloatingAddWOT extends PureComponent<IFloatingAddWOTProps, IFloatingAddWOTState> {
    isExtInstalled: boolean;
    browserName: string;

    constructor(props: Object) {
        super(props);
        this.state = {
            isSSR: true,
            closed: false
        };
        this.isExtInstalled = true; // true -> so that SSR won't load an empty browser image
    }

    componentDidMount() {
        // const hasClickedExtensionCTABefore = Boolean(window.localStorage.getItem(this.getStorageKey(EXTENSION_CTA_KEY))); TODO: do not remove - for future use
        // const hasClickedMobileCTABefore = Boolean(window.localStorage.getItem(this.getStorageKey(MOBILE_CTA_KEY))); TODO: do not remove - for future use
        const browser = getBrowserInfo();
        this.browserName = browser.name.toLowerCase();
        this.isExtInstalled = extInstalled;
        const closedBeforeValue = window.localStorage.getItem(getStorageKey(CLOSED_KEY, this.props.pageTrackName));
        const isClosedInitialValue = (closedBeforeValue === EXTENSION && !this.isExtInstalled) || closedBeforeValue === MOBILE || false;
        this.setState({
            isSSR: false,
            closed: isClosedInitialValue
        });
    }

    render(): any {
        const {isSSR, closed} = this.state;
        const {isHidden = false, isSafari = false, pageTrackName = 'general'} = this.props;

        return (
            <FloatingAddWOTContainer isHidden={isSafari || isHidden || isSSR || closed} data-automation="floating-add-wot">
                { this.isExtInstalled ?
                    <FloatingMobile pageTrackName={pageTrackName} onClose={this.onClose} />
                    :
                    <FloatingDesktop browserName={this.browserName} pageTrackName={pageTrackName} onClose={this.onClose} />
                }
                <CacheOnly>
                    <PhoneImg />
                    <BrowserImg browserName={'chrome'} />
                    <BrowserImg browserName={'firefox'} />
                </CacheOnly>
            </FloatingAddWOTContainer>
        );
    }

    onClose = (source: string) => {
        window.localStorage.setItem(getStorageKey(CLOSED_KEY, this.props.pageTrackName), source);
        this.setState({closed: true});
    }
}
